// Section 13, 18 and 22 (stream M4a): the Justice panel of the Society tab, the panel root. It
// reads the store's signals, builds the view model and dispatches the justice actions; every
// other component in this folder takes props. Safety and deterrence, the justice policy and guard
// mandate, the cases awaiting judgement (one JusticePrompt each), last season's unexplained
// losses, and the cases already judged. Mounting: see README.md in this folder.
import { useComputed } from '@preact/signals';
import {
  answerJustice,
  draft,
  game,
  runConfig,
  setGuardMandate,
  setJusticePolicy,
  status,
} from '../../../store';
import { justiceVM } from '../../../viewModels/justice';
import { justiceText as t } from '../../text/en';
import { Losses, ResolvedCases } from './case-tables';
import { JusticePrompt } from './justice-prompt';
import { PolicyControls } from './policy-controls';
import { SafetySummary } from './safety-summary';
import './justice.css';

export function JusticePanel() {
  const model = useComputed(() =>
    game.value === null ? null : justiceVM(game.value, draft.value, runConfig()),
  );
  const vm = model.value;
  if (vm === null) return null;
  const disabled = status.value !== 'deciding';
  return (
    <div class="justice">
      <h3>{t.title}</h3>
      <SafetySummary vm={vm} />
      <section class="justice__section" aria-labelledby="justice-pending-title">
        <h4 id="justice-pending-title">{t.pendingTitle}</h4>
        {vm.pending.length === 0 ? (
          <p class="justice-muted">{t.noPending}</p>
        ) : (
          vm.pending.map((c) => (
            <JusticePrompt key={c.id} vm={c} disabled={disabled} onAnswer={answerJustice} />
          ))
        )}
      </section>
      <PolicyControls
        vm={vm}
        disabled={disabled}
        onPolicy={setJusticePolicy}
        onMandate={setGuardMandate}
      />
      <Losses vm={vm} />
      <ResolvedCases vm={vm} />
    </div>
  );
}
